<template>
  <div class="reference-box">
    <div
      class="reference"
      :class="{
        [`reference--${createRenderType}`]: true,
        'reference-not-activated': !props.similarData
          ? modelDataStore.current_model?.supported_control_types?.length &&
            !modelDataStore.current_model?.supported_control_types?.includes(
              props.type
            )
          : modelDataStore.similar_mode_model?.supported_control_types
              ?.length &&
            !modelDataStore.similar_mode_model?.supported_control_types?.includes(
              props.type
            ),
      }"
      @click="doAddReference"
      :style="{
        '--background-color': renderData.typeMap[props.type].background,
        '--background-hover-color':
          renderData.typeMap[props.type].backgroundHover,
        '--background-mobile-color':
          renderData.typeMap[props.type].backgroundMobile,
      }"
    >
      <div
        class="reference-empty pointer flex"
        v-if="
          props.type == 'prompt'
            ? !renderData.referenceData?.content
            : !renderData.referenceData
        "
        :class="{
          'reference-used':
            userDataStore.isLogin &&
            renderData[`museLeadDataType_${props.type}`],
        }"
      >
        <div
          class="reference-corner-mark-beta tc"
          v-if="renderData.typeMap[props.type].isBeta"
        >
          <!-- {{ $$t("create.beta") }} -->
        </div>
        <div class="reference-icon-arrow"></div>
        <div class="reference-title-info flex1">
          <div class="reference-title flex">
            <div class="flex1 width-0 flex">
              <i
                class="block ico"
                :style="{
                  backgroundImage: `url(${
                    renderData.typeMap[props.type].icon
                  })`,
                  backgroundSize: '100% 100%',
                }"
              ></i>
              <span class="olh">{{
                renderData.typeMap[props.type].title
              }}</span>
              <div
                class="beta_plan tc"
                v-if="renderData.typeMap[props.type].isBeta"
              >
                {{ $$t("create.beta") }}
              </div>
              <div
                class="vip_plan tc"
                v-if="
                  renderData.typeMap[props.type].isVipPlan &&
                  userDataStore.userInfo?.user?.vip_level_name != 'pro'
                "
              >
                {{ $$t("create.pro_plan") }}
              </div>
            </div>
          </div>

          <div class="reference-info omlh-2">
            {{ renderData.typeMap[props.type].description }}
          </div>
        </div>
        <div class="reference-icon">
          <i
            class="block"
            :style="{
              backgroundImage: `url(${renderData.typeMap[props.type].icon})`,
              backgroundSize: '100% 100%',
            }"
          ></i>
        </div>
        <!-- <div
        class="reference-mask"
        v-if="!renderData[`museLeadDataType_${props.type}`]"
      ></div> -->
      </div>

      <Bubble
        placement="top"
        :disabled="
          !(props.lock && renderData[`museLeadDataType_${props.type}`])
        "
      >
        <template v-slot:content>
          <div class="reference-lock-tip">
            <div class="vip_plan tc">
              {{ $$t("create.pro_plan") }}
            </div>

            <div class="reference-lock-tip-text flex1">
              {{ renderData.typeMap[props.type].lockTip ?? "" }}
            </div>
          </div>
        </template>
        <div
          class="reference-not-empty pointer"
          v-if="
            props.type == 'prompt'
              ? renderData.referenceData?.content
              : renderData.referenceData != null
          "
          :class="{
            'reference-used': renderData[`museLeadDataType_${props.type}`],
            'disabled-midi':
              !ModuleOpenStateControl.speControl.motifReferMidiPlay &&
              tools.isMidiUrl(renderData.referenceData?.url),
          }"
        >
          <div
            class="reference-corner-mark-beta tc"
            v-if="renderData.typeMap[props.type].isBeta"
          >
            <!-- {{ $$t("create.beta") }} -->
          </div>
          <div class="reference-title flex">
            <div class="reference-title-text flex1 width-0 flex">
              <i
                class="block ico"
                :style="{
                  backgroundImage: `url(${
                    renderData.typeMap[props.type].icon
                  })`,
                  backgroundSize: '100% 100%',
                }"
              ></i>
              <span class="olh">{{
                renderData.typeMap[props.type].title
              }}</span>

              <i class="fn-inline right-arrow-ico"></i>

              <i
                class="fn-inline lock-ico"
                v-if="
                  props.lock && renderData[`museLeadDataType_${props.type}`]
                "
              ></i>
              <div
                class="vip_plan tc"
                v-if="
                  renderData.typeMap[props.type].isVipPlan &&
                  userDataStore.userInfo?.user?.vip_level_name != 'pro'
                "
              >
                {{ $$t("create.pro_plan") }}
              </div>
            </div>

            <div class="reference-using tc" @click.stop="doToogleUseReference">
              <i class="fn-inline"></i>
              <!-- <span class="fn-inline">{{ $$t("create.active") }}</span> -->
            </div>
          </div>
          <div
            class="reference-player-box"
            @click.stop
            v-if="props.type != 'prompt'"
          >
            <div
              class="reference-player-midi flex"
              v-if="
                !ModuleOpenStateControl.speControl.motifReferMidiPlay &&
                tools.isMidiUrl(renderData.referenceData?.url)
              "
            >
              <div class="reference-player-midi-box flex1 width-0"></div>
              <div
                class="reference-edit btn pointer"
                @click="doAddReference"
                v-if="props.hideCloseBtn !== true && !props.lock"
              >
                <i class="block"></i>
              </div>
            </div>
            <template v-else>
              <AudioPlayer
                :key="renderData.url"
                v-if="renderData.ifRender"
                ref="refPlayer"
                :url="
                  renderData.url
                    ? `${getObjectStorageFullUrl(renderData.url)}${
                        props.audioUrlSuffix
                      }`
                    : ''
                "
                :duration="renderData.duration"
                @syncDuration="syncDuration"
                @syncPlayState="syncPlayState"
                @syncLoadingState="syncLoadingState"
                @syncProgress="syncProgress"
              >
                <div class="reference-player flex">
                  <div class="reference-player-op-box">
                    <LoaderProgressCircle
                      :size="24"
                      :strokeWidth="1"
                      default-color="rgba(255,255,255,0.8)"
                      progress-color="#94ADFF"
                      :progress="0"
                    >
                      <div
                        class="reference-player-op flex-center"
                        @click.stop="doTogglePlay"
                      >
                        <i
                          class="block"
                          :class="{
                            'isplay-true': !renderData.isplay,
                            'isplay-false': renderData.isplay,
                          }"
                        ></i>
                      </div>
                    </LoaderProgressCircle>
                  </div>
                  <div class="reference-player-wav-box flex1 width-0">
                    <div class="reference-player-wav">
                      <AudioWavForm
                        :url="`${getObjectStorageFullUrl(renderData.url)}${
                          props.audioUrlSuffix
                        }`"
                        :hideChangeProgress="true"
                        :disableChangeProgress="false"
                        :waveformData="renderData.waveformData"
                        :progress="renderData.progress / 100"
                        @changeProgress="changeProgress"
                      ></AudioWavForm>
                    </div>
                  </div>
                  <div
                    class="reference-edit btn pointer"
                    @click="doAddReference"
                    v-if="props.hideCloseBtn !== true && !props.lock"
                  >
                    <i class="block"></i>
                  </div>
                  <!-- <div
              class="reference-delete btn pointer"
              @click.stop="doDeleteReference"
              v-if="props.hideCloseBtn !== true"
            >
              <i class="block"></i>
            </div> -->
                </div>
              </AudioPlayer>
            </template>
          </div>

          <div
            class="reference-describe-box flex"
            v-if="props.type == 'prompt'"
          >
            <Bubble
              :disabled="renderData.addPromptVisible"
              :content="renderData.referenceData?.content"
              placement="top"
            >
              <div class="reference-describe-text flex1 width-0 omlh-2">
                {{ renderData.referenceData?.content }}
              </div>
            </Bubble>
            <div
              class="reference-edit btn pointer"
              @click="doAddReference"
              v-if="props.hideCloseBtn !== true"
            >
              <i class="block"></i>
            </div>
            <!-- <div
          class="reference-delete btn"
          @click.stop="doDeleteReference"
          v-if="props.hideCloseBtn !== true"
        >
          <i class="block"></i>
        </div> -->
          </div>
          <div
            @click.stop="doToogleUseReference"
            class="reference-mask"
            v-if="!renderData[`museLeadDataType_${props.type}`]"
          ></div>
        </div>
      </Bubble>
      <!-- <div
      class="reference-vip_plan-mask"
      v-if="
        userDataStore.userInfo?.user?.vip_level_name != 'pro' &&
        renderData.typeMap[props.type].isVipPlan
      "
    ></div> -->
      <!-- <div
        class="add-vocal-new-corner-mark"
        v-if="
          !props.similarData &&
          modelDataStore.current_model?.supported_control_types?.length &&
          !modelDataStore.current_model?.supported_control_types?.includes(
            props.type
          )
        "
      >
        <span class="block">{{ $$t("common.new") }}</span>
      </div> -->
    </div>
    <Bubble
      v-if="
        !props.similarData
          ? modelDataStore.current_model?.supported_control_types?.length &&
            !modelDataStore.current_model?.supported_control_types?.includes(
              props.type
            )
          : modelDataStore.similar_mode_model?.supported_control_types
              ?.length &&
            !modelDataStore.similar_mode_model?.supported_control_types?.includes(
              props.type
            )
      "
      :content="$$t('editor.refer_model_not_suported')"
      placement="top"
      :disabled="createRenderType == 'mobile'"
    >
      <div
        class="reference-not-activated-mark flex-center"
        @click="
          () => {
            if (createRenderType == 'mobile') {
              shownotActivatedWarningDialog();
            }
          }
        "
      ></div>
    </Bubble>
    <AddReference
      @apply="doApplyMuseLeadDataType"
      v-model:visible="renderData.addReferenceVisible"
      v-if="renderData.addReferenceVisible"
      @showSubscribeDialog="showSubscribeDialog"
    ></AddReference>
    <AddMotif
      v-model:visible="renderData.editMotifVisible"
      v-if="
        renderData.editMotifVisible &&
        !ModuleOpenStateControl.create.motifReferCustom
      "
      @apply="doApplyMuseLeadDataType"
    ></AddMotif>
    <AddMotifRefer
      v-model:visible="renderData.editMotifVisible"
      v-if="
        renderData.editMotifVisible &&
        ModuleOpenStateControl.create.motifReferCustom
      "
      @apply="doApplyMuseLeadDataType"
      @showSubscribeDialog="showSubscribeDialog"
    ></AddMotifRefer>
    <AddVocal
      v-model:visible="renderData.addVocalVisible"
      v-if="renderData.addVocalVisible"
      @apply="doApplyMuseLeadDataType"
      @showSubscribeDialog="showSubscribeDialog"
    ></AddVocal>
    <AddPrompt
      @apply="doApplyMuseLeadDataType"
      v-model:visible="renderData.addPromptVisible"
      v-if="renderData.addPromptVisible"
    ></AddPrompt>
  </div>
  <SubscribeDialog
    @showUpModal="showUpModal"
    v-if="subscribeDialogVisible"
    :type="subscribeDialogType"
    :source="renderData.subscribeModelParams"
    v-model:visible="subscribeDialogVisible"
    @close="close"
  ></SubscribeDialog>
  <UpgradeDialog
    v-if="upgradeDialogVisible"
    v-model:visible="upgradeDialogVisible"
    :upgradeDialogData="upgradeDialogData"
    @handleUpgrade="handleUpgrade"
  ></UpgradeDialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  nextTick,
  getCurrentInstance,
} from "vue";
import { storeToRefs } from "pinia";
import { useRouter, useRoute } from "vue-router";

import globalConfig, {
  chinaAppName,
  ModuleOpenStateControl,
} from "@/config/config.js";
import tools from "@/utils/tools.js";
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js";

import AddReference from "./editReference/addReference.vue";
import AddVocal from "./editvocal/addReference.vue";
import AddMotif from "./editMotif/editRecord.vue";
import AddMotifRefer from "./editMotif/addReference.vue";
import AddPrompt from "./editPrompt/addReferPrompt.vue";
import Bubble from "@/components/bubble/bubble.vue";
import SubscribeDialog from "./subscribe-dialog/subscribe-dialog.vue";
import UpgradeDialog from "@/page/credits/components/upgrade.vue";
import { showActionDialog } from "@/components/functionCallComponent/action/action.js";

import IconButton from "@/components/basic/button/IconButton.vue";
import AudioPlayer from "@/components/media/audioPlayer/AudioPlayer.vue";
import LoaderProgressCircle from "@/components/animation/LoaderProgressCircle.vue";
import AudioWavForm from "@/components/media/audioPlayer/AudioWavForm.vue";
import message from "@/components/functionCallComponent/message/message.js";

import useMuseDataStore from "@/store/create/museDataStore.js";
import useDraftDataStore from "@/store/create/draftDataStore.js";
import useUserDataStore from "@/store/userDataStore.js";
import useModelDataStore from "@/store/model/modelDataStore.js";
import useGlobalPlayDataStore from "@/store/globalPlayDataStore.js";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";

import referenceIco from "@/assets/img/muse-refer-ico.png";
import motifIco from "@/assets/img/muse-recorder-ico.png";
import vocalIcon from "@/assets/img/muse-leadvocal-ico.png";
import promptIco from "@/assets/img/muse-description-ico.png";

import { upgrade } from "@/api/api/apiCredit.js";
const globalPlayDataStore = useGlobalPlayDataStore();
const museDataStore = useMuseDataStore();
const userDataStore = useUserDataStore();
const modelDataStore = useModelDataStore();
const createLayoutStore = useCreateLayoutStore();

const { createRenderType, create_createEditOpenState, vocalCornerMarkVisible } =
  storeToRefs(createLayoutStore);
const { $$language, $$t, $$tm, $$tValue } =
  getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {};

const props = defineProps({
  type: {
    type: String,
    default: "refer", // refer | vocal | motif | prompt
  },
  data: {
    type: Object,
    default: () => null,
  },
  audioUrlSuffix: {
    type: String,
    default: "",
  },
  lock: {
    type: Boolean,
    default: false,
  },
  similarData: {
    type: Object,
    default: null,
  },
});

const subscribeDialogVisible = ref(false);
const upgradeDialogVisible = ref(false);
const upgradeDialogData = ref({});
const allowed_behavior = ref("");
const subscribeDialogType = ref("reference");

const close = () => {
  subscribeDialogVisible.value = false;
};

const showUpModal = (data, action_type) => {
  allowed_behavior.value = action_type;
  close();
  upgradeDialogData.value = data;
  upgradeDialogVisible.value = true;
};

const handleUpgrade = async (product) => {
  const Router = (getCurrentInstance() || window?.$getVueCurrentInstance?.())
    .appContext?.config?.globalProperties?.$router;
  try {
    const { code, data, msg } = await upgrade({
      new_product_id: product?.product_id,
      action_type: allowed_behavior.value,
    });
    upgradeDialogVisible.value = false;
    if (code == 200) {
      localStorage.setItem("action_create_product", JSON.stringify(product));
      Router.go(0);
    } else if (code == 500) {
      message.error({
        content: "failed to switch plan, please try again later",
      });
    } else if (code == 8012) {
      message.error({
        content: "failed to switch plan, please try again later",
      });
    } else if (code == 8013) {
      message.error({
        content: "failed to switch plan, please try again later",
      });
    } else {
      message.error({
        content: msg,
      });
    }
  } catch (error) {
    upgradeDialogVisible.value = false;
    message.error({
      content: "failed to switch plan, please try again later",
    });
  }
};

const getTypeMap = () => {
  return {
    refer: {
      title: $$t("create.style"),
      icon: referenceIco,
      description: $$t("create.add_style"),
      background:
        "linear-gradient(180deg, rgba(115, 148, 255, 0.36) 0%, rgba(11, 36, 115, 0) 97%)",
      backgroundHover:
        "linear-gradient(180deg, rgba(115, 148, 255, 0.9) 0%, rgba(11, 36, 115, 0) 97%)",
      backgroundMobile: "rgba(101, 143, 227, 0.3)",

      lockTip: $$t("create.custom_reference_used"),
    },
    vocal: {
      title: $$t("create.vocal"),
      icon: vocalIcon,
      description: $$t("create.add_vocal"),
      background:
        "linear-gradient(180deg, rgba(212, 148, 255, 0.36) 0%, rgba(63, 13, 97, 0) 100%)",
      backgroundHover:
        "linear-gradient(180deg, rgba(212, 148, 255, 0.9) 0%, rgba(63, 13, 97, 0) 100%)",
      backgroundMobile: "rgba(142, 117, 207, 0.3)",
      lockTip: $$t("create.custom_vocal_used"),
      newCornerMask: true,
    },
    prompt: {
      title: $$t("create.prompt"),
      icon: promptIco,
      description: $$t("create.add_prompt"),
      background:
        "linear-gradient(180deg, rgba(81, 176, 220, 0.36) 0%, rgba(10, 69, 76, 0) 100%)",
      backgroundHover:
        "linear-gradient(180deg, rgba(81, 176, 220, 0.9) 0%, rgba(10, 69, 76, 0) 100%)",
      backgroundMobile: "rgba(49, 141, 132, 0.3)",
    },
    motif: {
      title: $$t("create.melody"),
      icon: motifIco,
      description: $$t("create.add_melody"),
      isBeta: true,
      isVipPlan: !ModuleOpenStateControl.create.motifReferCustom,
      background:
        "linear-gradient(180deg, rgba(200, 115, 154, 0.36) 0%, rgba(67, 25, 12, 0) 100%)",
      backgroundHover:
        "linear-gradient(180deg, rgba(200, 115, 154, 0.9) 0%, rgba(67, 25, 12, 0) 100%)",
      backgroundMobile: "rgba(167, 110, 180, 0.3)",
      lockTip: $$t("create.custom_melody_ideas_used"),
    },
  };
};

const emits = defineEmits([]);

const refPlayer = ref(null);
const renderData = reactive({
  addReferenceVisible: false,
  editMotifVisible: false,
  addVocalVisible: false,
  addPromptVisible: false,
  referenceData: null,
  url: "",
  duration: 0,
  isplay: false,
  buffer: false,
  progress: 0,
  ifRender: true,
  waveformData: [],
  typeMap: getTypeMap(),
  [`museLeadDataType_${props.type}`]: false,
  subscribeModelParams: {},
});

const shownotActivatedWarningDialog = () => {
  showActionDialog({
    hideCancel: true,
    content: $$t("editor.refer_model_not_suported"),
    confirmLabel: $$t("create.i_knew"),
    confirm: (closeAction) => {
      closeAction();
    },
    cancel(closeAction) {
      closeAction();
    },
  });
};

const syncDuration = (duration) => {
  renderData.duration = duration;
};

const syncPlayState = (playState) => {
  renderData.isplay = playState;
};

const syncLoadingState = (loadingState) => {
  renderData.buffer = loadingState;
};

const syncProgress = (progress) => {
  renderData.progress = progress;
};

const doTogglePlay = () => {
  refPlayer.value?.changeOp();
  museDataStore.changeMuseLeadDataType(props.type);
};
const changeProgress = (progress) => {
  refPlayer.value?.changeProgress(progress * 100);
};
const isDoEditMuse = computed(() => {
  return (
    renderData.addReferenceVisible ||
    renderData.editMotifVisible ||
    renderData.addVocalVisible
  );
});
const doToogleUseReference = () => {
  if (renderData[`museLeadDataType_${props.type}`]) {
    museDataStore.changeMuseLeadDataType(props.type, false);
    refPlayer.value?.changeOp(false);
  } else {
    museDataStore.changeMuseLeadDataType(props.type);
  }
};
const doApplyMuseLeadDataType = (isUsed) => {
  museDataStore.changeMuseLeadDataType(props.type, isUsed);
};
const showSubscribeDialog = (type, params) => {
  goSubscribe(params?.membership_source2);
  // renderData.subscribeModelParams = params;
  // subscribeDialogVisible.value = true;
  // subscribeDialogType.value = type;
};

const goSubscribe = async (membership_source2) => {
  if (await userDataStore.checkLoginStatus()) {
    const Router = (getCurrentInstance() || window?.$getVueCurrentInstance?.())
      .appContext?.config?.globalProperties?.$router;
    Router.push({
      name: "subscribe",
      query: {
        membership_source1: "membership_feature",
        membership_source2,
      },
    });
  }
};
const doAddReference = async () => {
  const globalProperties = (
    getCurrentInstance() || window?.$getVueCurrentInstance?.()
  ).appContext?.config?.globalProperties;
  // if (!(await userDataStore.checkLoginStatus())) {
  //   return;
  // }
  switch (props.type) {
    case "refer":
      globalProperties?.logClickEvent("create_advanced_mode_reference_enter", {
        type: userDataStore?.isLogin ? "sign_in" : "not_sign_in",
      });
      break;
    case "motif":
      globalProperties?.logClickEvent(
        "create_advanced_mode_melody_ideas_enter",
        {
          type: userDataStore?.isLogin ? "sign_in" : "not_sign_in",
        }
      );
      break;
    case "vocal":
      globalProperties?.logClickEvent("create_advanced_mode_vocal_enter", {
        type: userDataStore?.isLogin ? "sign_in" : "not_sign_in",
      });
      break;
    case "prompt":
      globalProperties?.logClickEvent(
        "create_advanced_mode_description_enter",
        {
          type: userDataStore?.isLogin ? "sign_in" : "not_sign_in",
        }
      );
      break;
    default:
      break;
  }
  if (
    ((props.type == "prompt" && renderData.referenceData?.content) ||
      (props.type != "prompt" && renderData.referenceData)) &&
    !renderData[`museLeadDataType_${props.type}`]
  ) {
    museDataStore.changeMuseLeadDataType(props.type);
    return;
  }
  switch (props.type) {
    case "refer":
      if (props.lock) {
      } else {
        renderData.addReferenceVisible = true;
      }
      break;
    case "motif":
      if (props.lock) {
      } else if (ModuleOpenStateControl.create.motifReferCustom) {
        renderData.editMotifVisible = true;
      } else {
        if (userDataStore?.userInfo?.user?.vip_level_name == "pro") {
          renderData.editMotifVisible = true;
        } else {
          // showSubscribeDialog("melody", {
          //   membership_source1: "membership_feature",
          //   membership_source2: "melody_ideas",
          // });
          goSubscribe("melody_ideas");
        }
      }

      break;
    case "vocal":
      if (props.lock) {
      } else {
        renderData.addVocalVisible = true;
      }
      break;
    case "prompt":
      renderData.addPromptVisible = true;
      break;
    default:
      break;
  }
};

const doDeleteReference = () => {
  museDataStore.changeMuseLeadDataType(props.type, false);
  switch (props.type) {
    case "refer":
      museDataStore.deleteReferenceData(props.type);
      break;
    case "motif":
      museDataStore.deleteMotifData(props.type);
      break;
    case "vocal":
      museDataStore.deleteVocalData(props.type);
      break;
    case "prompt":
      museDataStore.deletePromptData(props.type);
      break;
  }
};

const init = () => {
  switch (props.type) {
    case "refer":
      renderData.referenceData = museDataStore.referenceData;
      break;
    case "motif":
      renderData.referenceData = museDataStore.motifData;
      break;
    case "vocal":
      renderData.referenceData = museDataStore.vocalData;
      break;
    case "prompt":
      if (museDataStore.promptData?.content) {
        renderData.referenceData = museDataStore.promptData;
      } else {
        renderData.referenceData = null;
      }
      break;
  }

  renderData[`museLeadDataType_${props.type}`] =
    museDataStore[`museLeadDataType_${props.type}`];
  if (props.type == "prompt") {
    return;
  }
  if (renderData.url != renderData.referenceData?.url) {
    renderData.url = renderData.referenceData?.url;
    renderData.duration =
      (renderData.referenceData?.duration_milliseconds ?? 0) / 1000;
    renderData.ifRender = false;
    nextTick().then(() => {
      renderData.progress = 0;
      renderData.isplay = false;
      setTimeout(() => {
        renderData.ifRender = true;
      }, 10);
    });
  }
};

const onDeleteClick = () => {};

const doTempToggleGlobalPlay = (newValue) => {
  if (newValue) {
    globalPlayDataStore.tempToggle(true);
  } else {
    globalPlayDataStore.tempToggle(false);
  }
};

const handleMessage = () => {
  const usejson = localStorage.getItem("action_create_product") ?? "";
  const product = usejson ? JSON.parse(usejson ?? {}) : "";
  if (product && product.title) {
    message.success({
      content: `Successfully switch to ${product?.title}`,
    });
    localStorage.removeItem("action_create_product");
  }
};

watch(
  () => isDoEditMuse.value,
  (newValue) => {
    if (createRenderType.value != "mobile") {
      doTempToggleGlobalPlay(isDoEditMuse.value);
    } else {
      const appContext = (
        getCurrentInstance() || window?.$getVueCurrentInstance?.()
      ).appContext;
      appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.pause(
        appContext?.config?.globalProperties?.$globalMediaUtils
          ?.globalAudioPlayer?.currentUrl
      );
    }
  }
);

watch(
  () => userDataStore.appLanguage,
  (newVal) => {
    nextTick().then(() => {
      renderData.typeMap = getTypeMap();
    });
  }
);

watch(
  () => {
    return renderData.isplay;
  },
  (newValue) => {
    if (!isDoEditMuse.value && createRenderType.value != "mobile") {
      // doTempToggleGlobalPlay(newValue);
    }
  }
);

watch(
  () => museDataStore.timescamp,
  () => {
    init();
  }
);
watch(
  () => museDataStore[`museLeadDataType_${props.type}`],
  () => {
    renderData[`museLeadDataType_${props.type}`] =
      museDataStore[`museLeadDataType_${props.type}`];
    if (
      !renderData[`museLeadDataType_${props.type}`] &&
      renderData.referenceData
    ) {
      const appContext = (
        getCurrentInstance() || window?.$getVueCurrentInstance?.()
      ).appContext;
      appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.pause(
        `${getObjectStorageFullUrl(renderData.url)}${props.audioUrlSuffix}`
      );
    }
  }
);

watch(
  () => create_createEditOpenState.value,
  () => {
    if (create_createEditOpenState.value != "max") {
      const appContext = (
        getCurrentInstance() || window?.$getVueCurrentInstance?.()
      ).appContext;

      appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.pause(
        `${getObjectStorageFullUrl(renderData.url)}${props.audioUrlSuffix}`
      );
    }
  }
);

onMounted(() => {
  init();
  handleMessage();
});
</script>

<style lang="scss" scope>
.reference-box {
  position: relative;
  .reference-not-activated-mark {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }
}
.reference {
  position: relative;
  height: 94px;
  .add-vocal-new-corner-mark {
    height: 32px;
    width: 32px;
    position: absolute;
    top: 0;
    right: 0;
    background: url("@/assets/img/new-corner-mark.png");
    background-size: 100% 100%;
    border-radius: 0 12px 0 0;
    overflow: hidden;
    span {
      position: absolute;
      font-family: HarmonyOS Sans SC;
      height: 20px;
      width: 44px;
      font-size: 9px;
      font-weight: 500;
      line-height: 24px;
      text-align: center;
      color: #4c2a87;
      transform: rotate(45deg);
    }
  }

  .reference-vip_plan-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .reference-title {
    font-family: HarmonyOS Sans SC;
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    color: #ffffff;
    > div {
      align-items: center;
    }
    i.ico {
      margin: -2px 4px 0 0;
      height: 18px;
      width: 18px;
      display: none;
    }
    span {
      opacity: 1;
    }
  }
  .reference-empty {
    padding: 14px 14px 18px 14px;
    height: 94px;
    border-radius: 12px;
    align-items: center;
    background: var(--background-color);

    position: absolute;
    top: 0;
    left: 0;
    width: 100%;

    .reference-info {
      margin-top: 8px;
      font-family: HarmonyOS Sans SC;
      font-size: 12px;
      font-weight: normal;
      line-height: 16px;
      color: #ffffff;
      opacity: 0.5;
    }
    .reference-title {
      opacity: 1;
      margin-right: -4px;
    }
    .reference-icon {
      margin-left: 4px;
      width: 48px;
      height: 48px;
      border-radius: 48px;
      padding: 12px;
      background: rgba(255, 255, 255, 0.1);
      i {
        width: 24px;
        height: 24px;
        opacity: 1;
      }
    }
    &:hover {
      background: var(--background-hover-color);
      .reference-title {
        opacity: 1;
        color: #fff;
      }
      .reference-icon {
        i {
          opacity: 1;
        }
      }
      .reference-icon {
        padding: 14px;
        i {
          height: 20px;
          width: 20px;
          background: url("@/assets/img/add-refer-ico.png") !important;
          background-size: 100% 100% !important;
          opacity: 1 !important;
        }
      }
    }
    &.reference-used {
      opacity: 1;
      border: none;
      margin: 0 1px;
      .reference-title {
        opacity: 1;
        span {
          opacity: 1;
        }
        i.ico {
          height: 18px;
          width: 18px;
        }
      }
      .reference-info {
        opacity: 1;
      }
      .reference-icon {
        padding: 14px;
        i {
          height: 20px;
          width: 20px;
          background: url("@/assets/img/add-refer-ico.png") !important;
          background-size: 100% 100% !important;
          opacity: 1 !important;
        }
      }
      &:hover {
        background: var(--background-hover-color);
        .reference-info {
          opacity: 1;
        }
        .reference-icon {
          background: rgba(148, 173, 255, 0.5);
        }
        .reference-title {
          opacity: 1;
          color: #fff;
        }
      }
    }
  }
  // beta-corner-mark-ico.png
  .vip_plan {
    width: max-content;
    min-width: max-content;
    line-height: 14px;
    height: 14px;
    border-radius: 2px;
    padding: 0 2px;
    background: linear-gradient(110deg, #ffe08b 0%, #fff7d0 47%, #ffe08b 100%);
    font-family: HarmonyOS Sans SC;
    font-size: 8px;
    font-weight: 500;
    color: #3d2d00;
    margin: 0 0 0 4px;
  }
  .beta_plan {
    height: 14px;
    border-radius: 2px;
    opacity: 1;
    padding: 0 2px;
    border: 0.5px solid rgba(255, 255, 255, 0.8);
    font-family: HarmonyOS Sans SC;
    font-size: 8px;
    font-weight: normal;
    line-height: 14px;
    color: rgba(255, 255, 255, 0.8);
    margin: 0 0 0 4px;
    display: none;
  }
  .reference-corner-mark-beta {
    height: 32px;
    width: 32px;
    position: absolute;
    top: 0;
    right: 0;
    background: url("@/assets/img/beta-corner-mark-ico.png");
    background-size: 100% 100%;
  }
  .reference-not-empty {
    padding: 14px 14px 13px 14px;
    height: 94px;
    border-radius: 12px;
    align-items: center;
    background: var(--background-color);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    // border: solid 1px rgba(255, 255, 255, 0);

    .reference-using-old {
      height: 18px;
      border-radius: 54px;
      opacity: 1;
      background: rgba(0, 0, 0, 0.2);
      font-family: HarmonyOS Sans SC;
      font-size: 10px;
      font-weight: normal;
      color: #1dff12;
      display: none;
      padding: 0 6px;
      width: 48px;
      margin: -6px -6px 0 0;
      background: url("@/assets/img/refer-active-using-en.png");
      background-size: 100% 100%;
      &.reference-using-cn {
        background: url("@/assets/img/refer-active-using-cn.png");
        background-size: 100% 100%;
      }
      
      i {
        width: 4px;
        height: 4px;
        border-radius: 10px;
        background: #88ff82;
        display: none;
        box-shadow: 0px 0px 2px 1px rgba(77, 255, 69, 0.3);
      }
      span {
        padding: 0px 0 0 4px;
        line-height: 18px;
        display: none;
      }
    }

    .reference-using {
      width: 38px;
      height: 22px;
      margin: 0px -1px 0 0;
      width: 38px;
      height: 22px;
      border-radius: 40px;
      box-sizing: border-box;
      border: 1px solid rgba(255, 255, 255, 0.3);
      padding: 1px;
      display: flex;
      justify-content: start;
      i {
        width: 18px;
        height: 18px;
        border-radius: 18px;
        background: rgba(255, 255, 255, 0.8);
      }
    }

    .reference-title {
      height: 25px;
      span {
        opacity: 0.5;
        
      }
      i.ico{
        display: block;
        opacity: 0.5;;
      }
    }
    .reference-title-text {
      padding: 0 0 8px 0;
      i.right-arrow-ico {
        width: 20px;
        height: 20px;
        background-image: url(@/assets/img/right-arrow-white-ico.png);
        background-size: 100% 100%;
        margin: 0 2px;
        display: none;
      }
      i.lock-ico {
        width: 16px;
        height: 16px;
        background-image: url(@/assets/img/lock-yellow-ico.png);
        background-size: 100% 100%;
        margin: 0 2px 8px 4px;
      }
    }

    .reference-player {
      filter: grayscale(0.75);
      position: relative;
      opacity: 0.5;
      margin-right: -5px;
      align-items: center;
    }

    .reference-player-box {
      margin-left: -6px;
    }
    .reference-player-midi {
      height: 28px;
      align-items: center;
      margin-right: -5px;
      .reference-player-midi-box {
        height: 16px;
        margin: 0 8px 0 0;
        background-image: url("@/assets/img/midiTrackStrip.png");
        background-size: 100% 100%;
      }
    }
    .reference-player-op-box {
      width: 38px;
      height: 38px;
      padding: 5px;
    }
    .reference-player-op {
      width: 24px;
      height: 24px;
      border-radius: 24px;
      /* border: 1px solid #ffffff*/
      i {
        height: 12px;
        width: 12px;
      }
      .isplay-true {
        background: url("@/assets/img/play-light-ico.png");
        background-size: 100% 100%;
      }
      .isplay-false {
        background: url("@/assets/img/pause-light-ico.png");
        background-size: 100% 100%;
      }
    }
    .reference-player-wav-box {
      margin: 0 6px 0 6px;
    }
    .reference-player-wav {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 20px;
    }
    .reference-player-wav-item {
      width: 2px;
      background: linear-gradient(180deg, #98ff8e 9%, #3dd5ff 93%);
    }
    .reference-delete {
      height: 28px;
      width: 28px;
      padding: 6px;
      border-radius: 28px;
      i {
        width: 16px;
        height: 16px;
        background: url("@/assets/img/close-ico.png");
        background-size: 100% 100%;
      }
      &:hover {
        background: rgba(255, 255, 255, 0.1);
      }
    }
    .reference-edit {
      height: 28px;
      width: 28px;
      padding: 4px;
      border-radius: 28px;
      i {
        width: 20px;
        height: 20px;
        background-image: url(/src/assets/img/right-arrow-white-ico.png);
        background-size: 100% 100%;
      }
      &:hover {
        background: rgba(255, 255, 255, 0.1);
      }
    }

    .reference-describe-box {
      height: 38px;
      margin-right: -5px;
      align-items: center;
      .reference-delete {
        opacity: 0.5;
      }
      .reference-edit {
        margin-left: 4px;
      }
    }
    .reference-describe-text {
      font-size: 12px;
      line-height: 16px;
      font-weight: normal;
      color: rgba(255, 255, 255, 0.5);
    }

    &:hover {
      background: var(--background-hover-color);
      .reference-title {
        opacity: 1;
        color: #fff;
        &:hover {
          span {
            opacity: 1;
          }
        }
      }
      .reference-player {
        opacity: 0.5;
        filter: unset;
      }
      .reference-using {
        opacity: 1;
      }
    }
    &.reference-used {
      background: var(--background-color);

      .reference-title {
        opacity: 1;
        span {
          opacity: 1;
        }
        :hover {
          opacity: 1;
        }
        .vip_plan {
          margin: 0 0 8px 4px;
        }
        i.ico {
          display: block;
          opacity: 1;;
        }
      }
      .reference-player {
        opacity: 1;
        filter: unset;
      }
      .reference-using {
        background: linear-gradient(
          120deg,
          rgba(201, 255, 240, 0.7) 0%,
          rgba(103, 231, 226, 0.8) 99%
        );
        border: none;
        padding: 2px;
        justify-content: end;
        i {
          background: #ffffff;
        }
      }
      .reference-describe-box {
        .reference-delete {
          opacity: 1;
        }
      }
      .reference-describe-text {
        color: rgba(255, 255, 255, 1);
      }
      &:hover {
        background: var(--background-hover-color);
        .reference-title {
          opacity: 1;
          color: #fff;
        }
        .reference-title-text {
          opacity: 1;
        }
        .reference-describe-text:hover {
          color: rgba(255, 255, 255, 0.75);
        }
        .reference-player {
          filter: unset;
          opacity: 1;
          .reference-player-op-box:hover {
            opacity: 0.8;
          }
          .reference-player-wav-box:hover {
            opacity: 0.8;
          }
        }
        .reference-using {
          opacity: 1;
          &:hover {
            opacity: 0.75;
          }
        }
      }
    }

    &.disabled-midi {
      .reference-player-op-box {
        opacity: 0.5;
        pointer-events: none;
        cursor: not-allowed;
        .reference-player-op {
          cursor: not-allowed !important;
        }
      }
      .reference-player-wav-box {
        pointer-events: none;
        cursor: not-allowed !important;
      }
    }
  }
  .reference-mask {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 12px;
  }

  &.reference-not-activated {
    opacity: 0.5;
    pointer-events: none;
    .reference-using {
      background: none !important;
      border: 1px solid rgba(255, 255, 255, 0.3) !important;
    }
  }
}
.reference.reference--mobile {
  height: 76px;

  .beta_plan {
    height: 14px;
    border-radius: 2px;
    opacity: 1;
    padding: 0 2px;
    border: 0.5px solid rgba(255, 255, 255, 0.8);
    font-family: HarmonyOS Sans SC;
    font-size: 8px;
    font-weight: normal;
    line-height: 13px;
    color: rgba(255, 255, 255, 0.8);
    margin: 0 0 0 4px;
    display: block;
  }
  .reference-corner-mark-beta {
    display: none;
  }
  .reference-title {
    font-size: 18px;
  }
  .reference-empty {
    height: 76px;
    padding: 9px 14px;
    flex-direction: row-reverse;
    background: var(--background-mobile-color);
    .reference-title {
      opacity: 1;
      color: #fff;
      i.ico {
        display: block;
        margin: -2px 4px 0 0;
      }
    }
    .reference-info {
      margin-top: 8px;
    }
    .reference-icon-arrow {
      width: 24px;
      height: 24px;
      background-image: url(/src/assets/img/right-arrow-white-ico.png);
      background-size: 100% 100%;
      margin: 0 -4px 0 0;
    }
    .reference-title-info {
      margin: 0 12px 0 0;
    }
    .reference-icon {
      margin: 0;
      display: none;
    }
    &:hover {
      background: var(--background-mobile-color);
      opacity: 1;
      .reference-info {
        opacity: 0.5;
      }
      .reference-title {
        opacity: 1;
        color: #fff;
      }
      .reference-icon {
        i {
          opacity: 1;
        }
      }
    }
    &.reference-used {
      opacity: 1;
      border: none;
      margin: 0 1px;
      background: var(--background-mobile-color);
      .reference-title {
        opacity: 1;
      }
      .reference-info {
        opacity: 0.5;
      }
      .reference-icon {
        padding: 14px;
        i {
          height: 20px;
          width: 20px;
          background: url("@/assets/img/add-refer-ico.png") !important;
          background-size: 100% 100% !important;
          opacity: 1 !important;
        }
      }
      &:hover {
        background: var(--background-mobile-color);
        .reference-info {
          opacity: 0.5;
        }
        .reference-icon {
          background: rgba(148, 173, 255, 0.5);
        }
        .reference-title {
          opacity: 1;
          color: #fff;
        }
      }
    }
  }
  .reference-not-empty {
    height: 76px;
    padding: 12px 13px 10px 12px;
    background: var(--background-mobile-color);
    .reference-title {
      font-size: 14px;
    }
    .reference-player-box {
      margin: 4px 0 -12px 0;
    }
    .audio-waveform-container {
      margin-left: 4px;
    }
    .reference-delete {
      margin: 0 0 0 8px;
    }
    .reference-player-op-box {
      padding: 0;
      height: unset;
      width: unset;
    }
    .reference-title {
      height: 22px;
    }

    &:hover {
      background: var(--background-mobile-color);
    }

    &.reference-used {
      height: 76px;
      padding: 12px 13px 10px 12px;
      border: none;
      background: var(--background-mobile-color);
      .reference-title {
        height: 22px;
      }
      .reference-title-text {
        opacity: 1;
      }

      &:hover {
        background: var(--background-mobile-color);
        .reference-title {
          opacity: 1;
          color: #fff;
        }
        .reference-player {
          opacity: 1;
          filter: unset;
        }

        .reference-player-op-box:hover {
          opacity: 1;
        }
        .reference-player-wav-box:hover {
          opacity: 1;
        }

        .reference-using {
          opacity: 1;
        }
      }
    }
  }
}
.reference-lock-tip {
  display: flex;
  flex-direction: column;
  align-items: start;
  .vip_plan {
    width: max-content;
    min-width: max-content;
    line-height: 14px;
    height: 14px;
    border-radius: 2px;
    padding: 0 2px;
    background: linear-gradient(110deg, #ffe08b 0%, #fff7d0 47%, #ffe08b 100%);
    font-family: HarmonyOS Sans SC;
    font-size: 8px;
    font-weight: 500;
    color: #3d2d00;
    margin: 0 0 4px 0;
  }
}
</style>
